<template>
  <div class="from-connet">
    <div  class="cont2-img">
      <p>爱心无论大小，善举不分先后。所有善款，将全部用于爱心公益事业。予人玫瑰，手留余香，感谢您的善行！</p>
    </div>
    <div class="fromtable">
      <div class="fromidevo">
        <span class="fromidevo-span">我要捐物说明</span>
        <i class="iconfont">&#xe610;</i>
        <a href="">关于对新冠肺炎疫情防控一线医务人员及其家属展开人道救助的通知.doc</a>
      </div>
      <div class="fromidevo-from">
        <a-form-model
          ref="ruleForm"
          :model="form"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-model-item ref="name" label="捐赠者(单位名称)" prop="name">
            <a-input
              v-model="form.name"
              @blur="
                () => {
                  $refs.name.onFieldBlur();
                }
              "
            />
          </a-form-model-item>
          <a-form-model-item ref="people" label="联系人" prop="people">
            <a-input
              v-model="form.people"
              @blur="
                () => {
                  $refs.people.onFieldBlur();
                }
              "
            />
          </a-form-model-item>
          <a-form-model-item ref="phone" label="联系电话" prop="phone">
            <a-input
              v-model="form.phone"
              @blur="
                () => {
                  $refs.phone.onFieldBlur();
                }
              "
            />
          </a-form-model-item>
          <a-form-item label="上传PDF文件" extra="">
            <a-upload
              v-decorator="[
                'upload',
                {
                  valuePropName: 'fileList',
                  getValueFromEvent: normFile,
                },
              ]"
              name="logo"
              action="/upload.do"
              list-type="picture"
            >
              <a-button> <a-icon type="upload" />请选择文件上传</a-button>
            </a-upload>
          </a-form-item>
          <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
            <a-button type="primary" @click="submitForm('ruleForm')">
              立即捐款
            </a-button>
            <a-button type="primary" style="margin-left: 10px" @click="resetForm('ruleForm')" class="xzc">
              重置
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      confirmDirty: false,
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
       form: {
        name: '',
        people:'',
        phone:'',
      },
      rules: {
        name: [
          { required: true, message: '请输入捐赠者名称(单位名称)', trigger: 'blur' },
          { min: 2, max: 11, message: '名称不低于两个字高于11个字', trigger: 'blur' },
        ],
        people: [
          { required: true, message: '请输入自己名称', trigger: 'blur' },
          { min: 2, max: 11, message: '名称不低于两个字高于11个字', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { min: 11, max: 11, message: '电话号码不低于11', trigger: 'blur' },
        ],
      },
    };
  },

  components: {},
  beforeCreate() {
      // this.form = this.$form.createForm(this, { name: 'register' });
    },

  mounted(){},

  methods: {
    // handleSubmit(e) {
    //   e.preventDefault();
    //   this.form.validateFieldsAndScroll((err, values) => {
    //     if (!err) {
    //       console.log('Received values of form: ', values);
    //     }
    //   });
    // },
    normFile(e) {
      console.log('Upload event:', e);
      if (Array.isArray(e)) {
        return e;
      }
      return e && e.fileList;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  }
}

</script>
<style lang="less" scoped>
.cont2-img{
  width: 100%;
  height: 70px;
  background-image: url('../../assets/img/fromtable 2.png');
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cont2-img p{
  width: 774px;
  height: 20px;
  font-size: 16px;
  font-family: MicrosoftYaHeiUI;
  color: #FFFFFF;
  line-height: 20px;
}
.fromtable{
  width: 750px;
  height: 100%;
  margin: 0 auto;
}
.fromidevo{
  margin-top: 44px;
  width: 100%;
  height: 37px;
  background: #E7F2FF;
  display: flex;
  align-items: center;
}
.fromidevo-span{
  width: 85px;
  height: 18px;
  margin-left: 30px;
  font-size: 14px;
  font-family: MicrosoftYaHeiUI;
  color: #333333;
  line-height: 18px;
}
.fromidevo-from{
  margin-top: 20px;
}
.ant-input{
  width: 100%;
}
.ant-btn-primary{
  background-color: #C9C9C9;
  border-radius: 3px;
  width: 100px;
  height: 38px;
  font-size: 14px;
  font-family: MicrosoftYaHeiUI;
  color: #333333;
  line-height: 38px;
  border: none;
}
.ant-btn-primary:hover{
  background-color: #D1292E;
}
.xzc{
  background-color: #C9C9C9;
  border-radius: 3px;
  width: 100px;
  height: 38px;
  font-size: 14px;
  font-family: MicrosoftYaHeiUI;
  color: #333333;
  line-height: 38px;
}
.xzc:hover{
  background-color: #D1292E;
}
.xzc:hover span{
  color: #FFFFFFFF !important;
}
</style>